import BonsController from './bons.controller';

export default {
    template: require('./bons.html'),
    controller: BonsController
};
